export const allCountryHighlightColumns = [
  { key: "alias_derived_consignee_master_name", label: "Consignee Standardized Name" },
  { key: "alias_consignee_name", label: "Consignee Name" },
  { key: "alias_derived_shipper_master_name", label: "Shipper Standardized Name" },
  { key: "alias_shipper_name", label: "Shipper Name" },
  { key: "alias_derived_shipper_address", label: "Shipper Address" },
  { key: "alias_derived_consignee_address", label: "Consignee Address" },
  { key: "alias_derived_port_of_lading", label: "Port of Lading" },
  { key: "alias_derived_port_of_unlading", label: "Port of Unlading" },
  { key: "alias_product_description", label: "Product Description" },
  { key: "alias_product_keyword", label: "Product Keywords" },
  { key: "alias_product_description_english_ml", label: "Product Description" },
  { key: "alias_derived_hs_codes", label: "HS Code" },
  { key: "alias_estimated_hs_codes", label: "Estimated HS Code" },
  { key: "alias_six_digit_hs_code", label: "6 Digit HS Code" },
  { key: "alias_derived_shipper_stock_ticker", label: "Shipper Stock Ticker" },
  { key: "alias_derived_consignee_stock_ticker", label: "Consignee Stock Ticker" },
  { key: "alias_derived_shipper_parent_company_name", label: "Shipper Parent Name" },
  { key: "alias_derived_consignee_parent_company_name", label: "Consignee Parent Name" },
  { key: "alias_document_number", label: "Shipment Document Number" },
  { key: "alias_master_document_number", label: "Shipment Parent Document Number" },
  { key: "alias_vessel_name", label: "Vessel Name" },
  { key: "derived_secondary_notify_parties", label: "Secondary Notify Party" },
  { key: "derived_carrier_name", label: "Carrier Name" },
  { key: "derived_nvocc_name", label: "NVOCC Name" },
  { key: "master_bill_shipper_name", label: "Master Bill Shipper Name" },
  { key: "master_bill_consignee_name", label: "Master Bill Consignee Name" },
  { key: "master_bill_carrier_name", label: "Master Bill Carrier Name" },
  { key: "master_bill_notify_party", label: "Master Bill Notify Party" },
  { key: "derived_vocc_name_id_combined", label: "VOCC" },
  { key: "derived_freight_forwarder_name_id_combined", label: "Freight Forwarder" },
  { key: "derived_nvocc_name_id_combined", label: "NVOCC" },
  { key: "derived_producer_name_english", label: "Producer Name" },
  { key: "declaration_number", label: "Declaration Number" },
  { key: "derived_customs_office_name_english", label: "Customs Office Name" },
  { key: "customs_office_name_indonesian", label: "Customs Office Name (Indonesian)" },
];
